import React from 'react'
import veva from "../images/veva 1.jpg";
import vevaroom from "../images/veva 2.jpg";
import vevaroomnew from "../images/veva room.jpg";
import vevaroombath from "../images/vevaroom_bath.jpg";

function Delxueveva() {
  return (
    <div>
        <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>

  </div>

  <div className="carousel-inner">
    <div className="carousel-item active">
      <img src={veva} className="d-block w-100" alt="Deluxe_room Berhampore"/>
    </div>
    <div className="carousel-item">
      <img src={vevaroom} className="d-block w-100" alt="vevaroom Berhampore"/>
    </div>
    <div className="carousel-item">
      <img src={vevaroomnew} className="d-block w-100" alt="Deluxe_room Berhampore"/>
    </div>
    <div className="carousel-item">
      <img src={vevaroombath} className="d-block w-100" alt="Deluxe_room Berhampore"/>
    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
    </div>
  )
}

export default Delxueveva